import React from 'react';
import { makeStyles, MenuItem, Select } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import ClearIcon from '@material-ui/icons/Clear';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';

const useStyles = makeStyles({
  Root: {
    '& .MuiChip-deleteIcon': {
      height: '14px',
      width: '14px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #cad8ff',
      borderRadius: '10px'
    },
    '& .MuiSelect-select': {
      background: 'white',
      borderRadius: '10px',
      padding: ({ type, currentValue }) =>
        type === 'chip' && currentValue?.length !== 0 ? '8px 32px 8px 8px' : '14px 32px 14px 14px'
    },
    '& .MuiSelect-select:focus': {
      background: 'white'
    },
    fontFamily: 'Poppins',
    fontSize: '12px',
    minHeight: '42.25px',
    width: '100%'
  },
  chip: {
    background: '#f0f4ff',
    borderRadius: '8px',
    fontFamily: 'Poppins',
    fontSize: '12px',
    margin: 2
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  noData: {
    '& svg': {
      fontSize: '50px'
    },
    fontFamily: 'Poppins',
    fontSize: '18px',
    margin: '14px',
    opacity: '0.5',
    textAlign: 'center'
  },
  paper: {
    '& .MuiMenu-list': {
      padding: '0px'
    },
    '& .MuiMenuItem-root': {
      fontFamily: 'Poppins',
      fontSize: '14px'
    },
    '& .MuiMenuItem-root.Mui-selected': {
      background: '#e6f7ff',
      fontWeight: 'bold'
    },
    border: '1px solid #cad8ff',
    borderRadius: '0px 0px 14px 14px'
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      marginTop: '5px',
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  },
  anchorOrigin: {
    horizontal: 'left',
    vertical: 'bottom'
  },
  getContentAnchorEl: null,
  transformOrigin: {
    horizontal: 'left',
    vertical: 'top'
  }
};

const MultipleSelect = ({
  placeholder = '',
  type = 'text',
  currentValue = [],
  selectOptions = [],
  // eslint-disable-next-line no-unused-vars
  handleChange = (value) => {},
  styles = {}
}) => {
  const classes = useStyles({ currentValue, type });

  const handleDelete = (value) => {
    const filteredArray = currentValue.filter((item) => item !== value);
    handleChange(filteredArray);
  };

  function renderValue(selected, type) {
    if (selected.length === 0) {
      return <em>{placeholder}</em>;
    }

    if (type === 'text') {
      return selected.join(', ');
    }

    if (type === 'chip') {
      return (
        <div className={classes.chips}>
          {selected.map((value) => (
            <Chip
              key={value}
              className={classes.chip}
              deleteIcon={<ClearIcon />}
              label={value}
              onDelete={() => handleDelete(value)}
              onMouseDown={(event) => {
                event.stopPropagation();
              }}
            />
          ))}
        </div>
      );
    }
  }

  return (
    <Select
      className={classes.Root}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
      MenuProps={{ ...MenuProps, classes: { paper: classes.paper } }}
      multiple
      onChange={(event) => handleChange(event.target.value)}
      renderValue={(selected) => renderValue(selected, type)}
      style={styles}
      value={currentValue}
      variant="outlined"
    >
      {selectOptions.length === 0 ? (
        <div className={classes.noData}>
          <SentimentDissatisfiedIcon />
          <p>No Data</p>
        </div>
      ) : (
        selectOptions.map((name) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))
      )}
    </Select>
  );
};

export default MultipleSelect;
